import React, { useState, useEffect } from "react"
import{ isAuthenticated} from "../screens/helper"
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  }));

const DeleteUser = () => {
    const classes = useStyles()
    const [userDetails, setUserDetails] = useState([])
    const {user, token} = isAuthenticated();
    const[success, setSuccess] = useState(false)

    const deluser = (deleteId) => {
        fetch(`${process.env.REACT_APP_BACKEND}/deleteuser/${deleteId}/${user._id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(results => {
            console.log(results);   
            setSuccess("User Deleted")
        })
    }
    const undeluser = (deleteId) => {
        fetch(`${process.env.REACT_APP_BACKEND}/undeleteuser/${deleteId}/${user._id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(results => {
            console.log(results);   
            setSuccess("User Bring Back")
        })
    }
    
    const allusers = () => {
        fetch(`${process.env.REACT_APP_BACKEND}/allusers/${user._id}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(results => {
            console.log(results);
            setUserDetails(results)
        })
    }

    useEffect(() => {
        allusers()
    }, [])

    const successMessege = () => (
        <div className="row">
            <div className="col s12 center-align">
                <div className="card-panel green white-text" style={{display: success ? "" : "none"}}>
                    {success}
                </div>
            </div>
        </div>
        
    )

    return(
        <>
        {successMessege()}
        <div class="row ">
            <div class="col offset-s1 s10 center-align">
                <div class="card-panel green">
                    <span class="white-text">
                    {userDetails.length} Users
                    </span>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col offset-s1 s10">
                {userDetails.map(user => (
                    <ExpansionPanel key={user._id} style={{backgroundColor: user.isDeleted? "red" : "" }}>
                        <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <Typography className={classes.heading}>{user.name}</Typography>
                        <Typography className={classes.secondaryHeading} noWrap>{user.email}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                        <Typography>
                        <h6>FOLLOWERS</h6>
                            {user.followers.map(follow => (
                                <p>{follow.name}</p>
                                
                            ))}
                        <h6>FOLLOWING</h6>
                            {user.following.map(follow => (
                                <p>{follow.name}</p>

                            ))}
                            {!user.isDeleted ? (
                                <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={() => {deluser(user._id)}}>
                                    Delete
                                </button>
                            ) : (
                                <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={() => {undeluser(user._id)}}>
                                    Bring Back
                                </button>
                            ) }
                            
                        </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                ))}
            </div>
        </div>
        </>
    )
}

export default DeleteUser;